<style>
.th-col {
  font-weight: bold;
  background-color: gainsboro;
  font-size: 12px;
  padding-top: 4px;
  padding-bottom: 4px;
}
.td-dia {
  font-size: 15px;
  background-color: white;
  padding-top: 4px;
  padding-bottom: 4px;
}
input[type="text"] {
  height: 30px;
  font-size: 12px;
  font-weight: bold;
}
.col-total {
  padding-top: 10px;
  padding-bottom: 14px;
}
label {
  font-size: 12px;
  font-weight: bold;
}
</style>

<template>
  <div>
    <base-header type class="rsgradient pb-3 pb-1 pt-3 pt-md-5"></base-header>

    <b-card>
      <b-card-header header-tag="header" class="p-1" role="tab">Calendario de Acreditaciones</b-card-header>

      <b-card-body>
        <div class="row" style="border: 1px solid #d6d4d4;">
          <div class="col-sm-1" style="padding-top:6px">
            <label>Buscar</label>
          </div>
          <div class="col-sm-3" style="padding-bottom:6px;padding-top:6px">
            <KitsCombo
              v-model="model.searchDate"
              v-bind:items="model.searchDates"
              v-on:input="getAccreditationCalendar"
              propertyName="Description"
              propertyID="ID"
            ></KitsCombo>
          </div>
        </div>

        <div class="row" style="padding-bottom:30px"></div>

        <div v-if="this.model.listPerDayLenght == 0" class="text-center">
          <div>No se encontraron registros</div>
          <img src="/img/ic_no_resultado.png" style="width: 200px;" />
        </div>
        <div v-else style="overflow-y:scroll;max-height: 370px;overflow-y: auto;overflow-x:hidden">
          <div class="row" style="padding-right:15px;">
            <div class="col-2 text-center th-col">Fecha</div>
            <div class="col-3 text-center th-col">Cobros</div>
            <div class="col-3 text-center th-col">Comisiones</div>
            <div class="col-3 text-center th-col">A Acreditar</div>
            <div class="col-1 text-center th-col"></div>
          </div>
          <div
            v-for="itemDay in this.model.listPerDay"
            v-bind:key="itemDay.Date"
            style="border-bottom: 1px solid #d6d4d4; margin-right: 0; margin-left: 0"
          >
            <div
              class="row"
              style="border-bottom: 1px solid #d6d4d4; margin-right: 0; margin-left: 0"
            >
              <div class="col-2 text-center td-dia">{{itemDay.FormattedDate}}</div>
              <div class="col-3 text-center td-dia">{{itemDay.FormattedAmount}}</div>
              <div class="col-3 text-center td-dia">{{itemDay.FormattedTransactionCommissionValue}}</div>
              <div class="col-3 text-center td-dia">{{itemDay.FormattedAmountToCredit}}</div>
              <div class="col-1 text-center td-dia"></div>
            </div>
          </div>
        </div>

        <div
          v-if="this.model.listPerDayLenght > 0"
          class="row"
          style="border: 1px solid #d6d4d4;margin-top: 30px"
        >
          <div class="col-md-2 text-center col-total" style="padding-top:35px">
            <label>Resumen Total</label>
          </div>
          <div class="col-md-2 text-center col-total">
            <label>Total Cobrado</label>
            <input
              type="text"
              class="form-control text-right"
              readonly
              v-model="model.totales.totalCobrado"
            />
          </div>
          <div class="col-md-2 text-center col-total">
            <label>Total Comisiones</label>
            <input
              type="text"
              class="form-control text-right"
              readonly
              v-model="model.totales.totalComisiones"
              style="color:red"
            />
          </div>
          <div class="col-md-2 text-center col-total">
            <label>Total a Acreditar</label>
            <input
              type="text"
              class="form-control text-right"
              readonly
              v-model="model.totales.totalAcreditar"
              style="color:green"
            />
          </div>
        </div>

        <div class="row" style="margin-top: 30px">
          <div class="col-md-12 text-left">
            <b-button class="btn btn-danger" @click="goBack()">
              <i class="fa fa-arrow-circle-left fa-fw"></i>Volver
            </b-button>
          </div>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import axiosHelpers from "@/helpers/axiosHelpers";
import KitsCombo from "@/components/KitsCombo";
import datetimeHelpers from "@/helpers/datetimeHelpers";
import DateTime from "luxon/src/datetime.js";
import KitsDate from "@/components/KitsDate";

export default {
  components: { KitsDate, KitsCombo },
  data() {
    return {
      model: {
        searchDate: 3,
        searchDates: [
          { ID: 1, Description: "Mañana" },
          { ID: 2, Description: "Próximos 3 días" },
          { ID: 3, Description: "Próximos 7 días" },
          { ID: 4, Description: "Todo" }
        ],
        totales: {
          totalCobrado: "",
          totalComisiones: "",
          totalAcreditar: ""
        },
        listPerDay: [],
        listPerDayLenght: 0
      }
    };
  },
  methods: {
    goBack() {
      this.$router.push("SmartPost");
    },
    getInitialDate() {
      var dt = DateTime.local();
      var ret = DateTime.local(parseInt(dt.year) - 1, 1, 1, 0, 0);
      return ret.toString();
    },
    getDayFromToday(daysNumber) {
      var dt = DateTime.local().plus({ days: daysNumber });
      var ret = DateTime.local(dt.year, dt.month, dt.day, 0, 0);
      return ret.toString();
    },
    getInitialSearchDate() {
      if (
        this.model.searchDate == 1 ||
        this.model.searchDate == 2 ||
        this.model.searchDate == 3
      )
        return this.getInitialDate();
      else return null;
    },
    getSearchDate() {
      if (this.model.searchDate == 1) return this.getDayFromToday(2);
      else if (this.model.searchDate == 2) return this.getDayFromToday(4);
      else if (this.model.searchDate == 3) return this.getDayFromToday(8);
      else return null;
    },
    getAccreditationCalendar() {
      let context = this;

      axiosHelpers.axiosGet(
        "OperationsFintouch/GetAccreditationCalendar",
        {
          DateFrom: context.getInitialSearchDate(),
          DateTo: context.getSearchDate()
        },
        this,
        function(response) {
          context.model.ListPerDay = response.ResponseVM.ListPerDay;

          context.model.listPerDay = [];

          context.model.totales.totalCobrado =
            response.ResponseVM.FormattedTotalAmount;
          context.model.totales.totalComisiones =
            response.ResponseVM.FormattedTotalTransactionCommissionValue;
          context.model.totales.totalAcreditar =
            response.ResponseVM.FormattedTotalAmountToCredit;

          response.ResponseVM.ListPerDay.forEach(x => {
            var day = {
              Date: x.Date,
              FormattedDate: x.FormattedDate,
              FormattedAmount: x.FormattedAmount,
              FormattedTransactionCommissionValue:
                x.FormattedTransactionCommissionValue,
              FormattedAmountToCredit: x.FormattedAmountToCredit
            };

            context.model.listPerDay.push(day);
          });
          context.model.listPerDayLenght = context.model.listPerDay.length;
        }
      );
    }
  },
  mounted() {
    this.getAccreditationCalendar();
  }
};
</script>